export default "__VITE_ASSET__Dd8IFTJh__"